<div class="text-center" style="padding-top: 4%; padding-bottom: 4%;">
    <a routerLink="/" role="button">
        <img src="/assets/images/deal-simple-logo_480.png" style="max-height: 65px">
    </a>
</div>